import { useQuery } from "@tanstack/react-query";
import { apiFetch, ApiClientError } from "@/lib/api-client";
import { queryKeys } from "@/lib/query-keys";
import type { PartnerGoal, PartnerGoalTarget } from "@colab/shared";

// GET /api/portal/goals — partner's active goals + their currently-active
// target (the one whose period covers today, or the most recent if today
// falls outside any period). Mirrors PartnerGoalSummary from
// apps/api/src/services/goals.ts.
export type PartnerGoalSummary = {
  goal: PartnerGoal;
  target: PartnerGoalTarget | null;
};

export function usePortalGoals() {
  return useQuery<PartnerGoalSummary[], ApiClientError>({
    queryKey: queryKeys.portal.goals(),
    queryFn: () => apiFetch<PartnerGoalSummary[]>("/portal/goals"),
  });
}
